export interface NoteData {
    job_id: string;
    note_text: string;
    note_type: NoteType;
    note_id?: string;
}

export enum NoteType {
    general = "General",
    material = "Material",
    labor = "Labor",
    assignment = "Assignment",
    completed_attachment = "Completed Attachment",
    in_progress_attachment = "In Progress Attachment",
}
